/**
 * created by liubo on 2020-03-25
 *
 * description：框架协议模块接口地址配置
 *
 */

const config = require('libs/config.js')

const agreement = {
	// 暂存协议
	tempSave: role => config.MS_XY_PATH + `/outline/${role}/agreement/saveAsTemp`,
	// 保存协议
	save: role => config.MS_XY_PATH + `/outline/${role}/agreement/save`,
	// 协议按状态查询
	getAgreementList: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/`,
	// 删除协议
	deleteAgreement: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/agreement/deleteTemp/${pkid}`,
	// 提交协议库
	submitAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/submit`,
	// 暂停协议
	pauseAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/suspend`,
	// 启用协议
	enableAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/enable`,
	// 协议详情
	getAgreementInfo: (role, id) => config.MS_XY_PATH + `/outline/${role}/agreement/info/${id}`,
	// 通过code 获取协议详情
	getAgreementByCode: (role, code) => config.MS_XY_PATH + `/outline/${role}/agreement/code/${code}`,
	// 终止协议
	applyAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/cancel/apply`,
	// 同意终止协议
	agreeCancelAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/cancel/agree`,
	// 拒绝协议终止协议
	rejectCancelAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/cancel/reject`,
	// 协商变更协议
	changeAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/change`,
	// 修改协议
	modifyAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/modify`,
	// 修改提交协议
	modifySubmitAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/modifyAndSubmit`,
	// 确认变更协议
	agreeChangeAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/change/agree`,
	// 驳回变更协议
	rejectChangeAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/change/reject`,
	// 获取协议相关订单
	getOrderByAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/order`,
	// 获取协议变更信息
	getHistory: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/agreement/change/${pkid}`,
	// 导出协议相关订单
	exportOrder: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/orderExport`,
	// 撤回协议
	recallAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/cancel`,
	// 驳回协议
	rejectAgreement: (role) => config.MS_XY_PATH + `/outline/${role}/agreement/reject`,
	// 编辑查询详情
	getAgreementInfoForEdit: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/agreement/infoForUpdate/${pkid}`,
	// 同意协议
	confirmAgreement: role => config.MS_XY_PATH + `/outline/${role}/agreement/confirm/agree`,
	// 拒绝协议
	refuseAgreement: role => config.MS_XY_PATH + `/outline/${role}/agreement/confirm/reject`,

	// 卖方根据询价单号查询详情
	getSellAgreementByInquiry: config.MS_XY_PATH + '/outline/inquiry/findContract',
	// 买方根据询价单号查询详情
	getBuyAgreementByInquiry: config.MS_XY_PATH + '/outline/inquiry/findBuyContract',

	// 获取菜单协议库数量
	getAgreementCount: role => config.MS_XY_PATH + `/outline/${role}/agreement/count`

}

export default agreement



// WEBPACK FOOTER //
// ./src/api/agreement/index.js